module.exports = __webpack_public_path__ + "static/img/huapai2.da8a7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huapai2.png
// module id = sgnc
// module chunks = 1